/**
 *
 * CustomTime
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment';

// styles
import './style.scss';

// antd component
import { Form, TimePicker } from 'antd';

// icons
//import CustomIcons from 'components/CustomIcons';

function CustomTime({
  format,
  label,
  name,
  required,
  initialValue,
  // actions
  onChange,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('tcf-time-wrapper', className);

  return (
    <Form.Item
      className={childClassNames}
      key={`${name}-date-select`}
      label={label}
      name={name}
      initialValue={initialValue}
      rules={[
        {
          required: required,
          message: 'Veuillez sélectionner la time',
        },
      ]}
      {...rest}
    >
      <TimePicker onChange={onChange} format={format} />
    </Form.Item>
  );
}

CustomTime.defaultProps = {
  required: true,
  label: 'Heure',
  format: 'HH:mm',
};
CustomTime.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  format: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func,
};

export default memo(CustomTime);
